import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
var _excluded = ["expand"];
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { styled, useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslate } from '@mui/docs/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ExpandMore = styled(function (props) {
  var expand = props.expand,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(IconButton, _extends({}, other));
})(function (_ref) {
  var theme = _ref.theme;
  return {
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    variants: [{
      props: function props(_ref2) {
        var expand = _ref2.expand;
        return !expand;
      },
      style: {
        transform: 'rotate(0deg)'
      }
    }, {
      props: function props(_ref3) {
        var expand = _ref3.expand;
        return !!expand;
      },
      style: {
        transform: 'rotate(180deg)'
      }
    }]
  };
});
var baseUrl = process.env.NEXT_PUBLIC_MUI_CHAT_API_BASE_URL;
function SuggestionButton(_ref4) {
  var handleClick = _ref4.handleClick,
    loading = _ref4.loading,
    suggestion = _ref4.suggestion;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      px: 2,
      pb: 2
    },
    children: /*#__PURE__*/_jsx(Button, {
      variant: "outlined",
      sx: {
        textTransform: 'none',
        fontWeight: 400,
        fontSize: {
          xs: '0.75rem',
          sm: '0.875rem'
        },
        py: 1,
        boxShadow: 'none'
      },
      onClick: handleClick,
      disabled: loading,
      startIcon: loading ? /*#__PURE__*/_jsx(CircularProgress, {
        color: "inherit",
        size: 16
      }) : null,
      children: suggestion
    })
  });
}
export default function DemoAiSuggestionHero(_ref5) {
  var suggestion = _ref5.suggestion,
    params = _ref5.params,
    sx = _ref5.sx,
    onSuccess = _ref5.onSuccess;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    error = _React$useState4[0],
    setError = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    expanded = _React$useState6[0],
    setExpanded = _React$useState6[1];
  var theme = useTheme();
  var isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  var handleExpandClick = function handleExpandClick() {
    setExpanded(!expanded);
  };
  var t = useTranslate();
  if (!baseUrl) {
    return null;
  }
  var handleClick = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setError(null);
            _context.prev = 1;
            _context.next = 4;
            return fetch("".concat(baseUrl, "/v1/public/chat/open"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(_extends({}, params, {
                type: 'mui-docs'
              }))
            });
          case 4:
            response = _context.sent;
            if (response.ok) {
              _context.next = 7;
              break;
            }
            throw new Error('Failed to open in MUI Chat');
          case 7:
            _context.next = 9;
            return response.json();
          case 9:
            data = _context.sent;
            if (onSuccess) {
              onSuccess(data.nextUrl);
            }
            window.open(data.nextUrl, '_blank');
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            setError(_context.t0);
          case 17:
            _context.prev = 17;
            setLoading(false);
            return _context.finish(17);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 14, 17, 20]]);
    }));
    return function handleClick() {
      return _ref6.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs(Box, {
    sx: _extends({
      border: '1px solid',
      borderColor: 'divider',
      borderTop: 'none',
      borderRadius: {
        xs: 0,
        sm: '0 0 12px 12px'
      },
      p: 0,
      backgroundColor: 'background.paper',
      boxShadow: 0,
      maxWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    }, sx),
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        px: 2,
        pt: 2,
        pb: 1
      },
      children: [/*#__PURE__*/_jsx(AutoAwesomeIcon, {
        fontSize: "small",
        sx: {
          color: 'primary.main',
          mr: 1
        }
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        sx: {
          fontWeight: 600
        },
        children: t('aiCustomizeDemo')
      }), isSmallScreen ? /*#__PURE__*/_jsx(ExpandMore, {
        expand: expanded,
        onClick: handleExpandClick,
        "aria-expanded": expanded,
        "aria-label": t('seeMore'),
        children: /*#__PURE__*/_jsx(ExpandMoreIcon, {})
      }) : null]
    }), isSmallScreen ? /*#__PURE__*/_jsx(Collapse, {
      "in": expanded,
      timeout: "auto",
      unmountOnExit: true,
      children: /*#__PURE__*/_jsx(SuggestionButton, {
        loading: loading,
        suggestion: suggestion,
        handleClick: handleClick
      })
    }) : /*#__PURE__*/_jsx(SuggestionButton, {
      loading: loading,
      suggestion: suggestion,
      handleClick: handleClick
    }), /*#__PURE__*/_jsx(Snackbar, {
      open: !!error,
      color: "error",
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      onClose: function onClose() {
        return setError(null);
      },
      autoHideDuration: 6000,
      children: /*#__PURE__*/_jsxs(Alert, {
        onClose: function onClose() {
          return setError(null);
        },
        severity: "error",
        sx: {
          width: '100%'
        },
        children: [/*#__PURE__*/_jsx(AlertTitle, {
          children: t('aiChatFailed')
        }), error == null ? void 0 : error.message]
      })
    })]
  });
}